import { api } from '@/lib/api/axios';
import type {
  BookingFeedbackContextDto,
  BookingFeedbackDto,
  CreateBookingFeedbackRequestDto,
} from '@/types/dto/feedback.dto';

export const FeedbackService = {
  getForBooking: async (bookingId: string): Promise<BookingFeedbackContextDto> => {
    const { data } = await api.get<BookingFeedbackContextDto>(`/booking/${bookingId}/feedback`);

    return data;
  },
  createForBooking: async (
    bookingId: string,
    payload: CreateBookingFeedbackRequestDto,
  ): Promise<BookingFeedbackDto> => {
    const { data } = await api.post<BookingFeedbackDto>(`/booking/${bookingId}/feedback`, payload);

    return data;
  },
};
